export const enSkills = {
  "skills.title": "Skills",
  "skills.subtitle": "Domain guidelines, procedures, and specialized tool packages.",
  "skills.import": "Import Skill",
  "skills.searchPlaceholder": "Search skills...",
  "skills.scope": "Scope:",
  "skills.allScopes": "All Scopes",
  "skills.platform": "Platform",
  "skills.organization": "Organization",
  "skills.project": "Project",
  "skills.loading": "Loading skills...",
  "skills.failed": "Failed to load skills.",
  "skills.colName": "Name",
  "skills.colDescription": "Description",
  "skills.colScope": "Scope",
  "skills.colStatus": "Status",
  "skills.colActions": "Actions",
  "skills.details": "Details",
  "skills.export": "Export",
  "skills.empty": "No skills found. Import a SKILL.md package to get started.",
  "skills.version": "Version",
  "skills.hash": "Hash",
  "skills.created": "Created",
  "skills.instructions": "Instructions (SKILL.md)",
  "skills.assets": "Assets",
  "skills.bytes": "bytes",
  "skills.noActiveVersion": "No active version published for this skill.",
  "skills.close": "Close",
  "skills.importTitle": "Import SKILL.md Package",
  "skills.platformGlobal": "Platform (Global)",
  "skills.contentLabel": "SKILL.md Content",
  "skills.cancel": "Cancel",
  "skills.importing": "Importing...",
  "skills.placeholderSkillMd": "Paste SKILL.md content with YAML frontmatter",
} as const;
